module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/72218665b9c5f665f8a81f2fa31a4eb8.png";